import * as React from "react";
import {
  Button,
  Menu,
  MenuItem,
  Fade,
  Container,
  Box,
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Colors } from "Utils/colors";
import { LocalImage } from "Utils/images";
import { useAppDispatch, useAppSelector } from "Hooks/reduxHook";
import { RootState } from "Features/store";
import { firstLetterCaps } from "Utils/transform";
import IconButton from "@mui/material/IconButton";
import CancelIcon from "@mui/icons-material/Cancel";
import { useFormik } from "formik";
import { editUser } from "Features/slice/userSlice";
import { updateUser } from "Features/slice/userSlice";
import { useContext } from "react";
import { SnackBarContext } from "Context/SnackContext";

export default function CurrentUser() {
  
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const { handleSnackbar } = useContext(SnackBarContext);

  const { firstname, lastname, role, username, email, phone, user_id } =
    useAppSelector((state: RootState) => state.user.userInfo);

  const uName = `${firstname} ${lastname || ""}`;

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };  


  const [showProfile, setShowProfile] = React.useState(false);
  const handleClose = (openDialog: boolean) => {
    setAnchorEl(null);
    openDialog && setShowProfile(true);
  };
  const closeShowProfileModal = () => {
    setShowProfile(false);
  };
  const dispatch = useAppDispatch();

  const initialValues = {
    firstname,
    lastname,
    phone,
    email,
    password: "",
  };
  const userForm = useFormik({
    initialValues,
    enableReinitialize: true,
    onSubmit: () => {},
  });

  const updateProfile = () => {
    const payload = {
      user_id: parseInt(user_id),
      first_name: userForm.values.firstname,
      last_name: userForm.values.lastname,
      username,
      email: userForm.values.email,
      phone: userForm.values.phone,
      password: userForm.values.password,
      role_name: role,
      is_active: 1,
    };
    dispatch(
      editUser({
        payload,
        successCB: (response: any) => {
          dispatch(
            updateUser({
              firstname: userForm.values.firstname,
              lastname: userForm.values.lastname,
              email: userForm.values.email,
              phone: userForm.values.phone,
              password: userForm.values.password,
            })
          );

          userForm.resetForm();
          // alert("User Updated Successfully!");
        },
        failureCB: (error: any) => {
          const message =
            error?.response?.data?.message || "Something went wrong";
        },
      })
    );
    handleSnackbar(true, "User information updated successfully");
    setShowProfile(false);
  };

  return (
    <Container>
      <Box
        sx={{
          border: 1,
          backgroundColor: "#2098bf",
          mt: 3,
          boxShadow: 1,
          color: Colors.white,
          borderRadius: 2,
          borderColor: "#f3f3f3",
        }}
      >
        <Button
          id="fade-button"
          aria-controls={open ? "fade-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
          endIcon={<ArrowDropDownIcon />}
          sx={{
            color: Colors.white,
            width: "100%",
            justifyContent: "center",
          }}
        >
          {/* <Box
            sx={{
              border: 1,
              borderColor: Colors.white,
              width: 35,
              mr: 1,
              textTransform: "none",
            }}
            component="img"
            alt=""
            src={LocalImage.samProfile}
          /> */}
          <Box sx={{ lineHeight: "15px" }}>
            <Typography
              variant="subtitle1"
              lineHeight={1}
              className="current-user-name"
            >
              {uName}
            </Typography>
            <Typography
              lineHeight={1}
              variant="caption"
              sx={{ textAlign: "left", whiteSpace: "normal" }}
            >
              {firstLetterCaps(role)}
            </Typography>
          </Box>
        </Button>
      </Box>
      <Menu
        className="dropdownMenu"
        id="fade-menu"
        MenuListProps={{
          "aria-labelledby": "fade-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={() => handleClose(false)}
        TransitionComponent={Fade}
      >
        <MenuItem
          className="myProfileDropdown"
          onClick={() => handleClose(true)}
        >
          My Profile
        </MenuItem>
      </Menu>
      <Dialog
        open={showProfile}
        onClose={() => setShowProfile(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Grid container spacing={2} alignItems={"center"}>
          <Grid item md={10}>
            <Box display="flex" justifyContent="center">
              <DialogTitle></DialogTitle>
            </Box>
          </Grid>
          <Grid item md={2}>
            <Tooltip title="Cancel" style={{ marginRight: 8, float: "right" }}>
              <IconButton onClick={closeShowProfileModal}>
                <CancelIcon />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item sm={12}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    autoComplete="given-name"
                    name="firstName"
                    required
                    fullWidth
                    id="firstName"
                    label="First Name"
                    autoFocus
                    value={userForm.values.firstname}
                    onChange={userForm.handleChange("firstname")}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    required
                    fullWidth
                    id="lastName"
                    label="Last Name"
                    name="lastName"
                    autoComplete="family-name"
                    value={userForm.values.lastname}
                    onChange={userForm.handleChange("lastname")}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item sm={12}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    autoComplete="email-address"
                    name="emailAddress"
                    required
                    fullWidth
                    id="emailAddress"
                    label="Email Address"
                    value={userForm.values.email}
                    onChange={userForm.handleChange("email")}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    autoComplete="phone"
                    name="phone"
                    required
                    fullWidth
                    id="phone"
                    label="Phone"
                    value={userForm.values.phone}
                    onChange={userForm.handleChange("phone")}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item sm={12}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <TextField
                    autoComplete="password"
                    name="password"
                    required
                    fullWidth
                    id="password"
                    label="Password"
                    type="password"
                    value={userForm.values.password}
                    onChange={userForm.handleChange("password")}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <Box
          sx={{
            textAlign: "center",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button
            variant="contained"
            sx={{ mt: 3, mb: 3, mr: 1 }}
            onClick={updateProfile}
          >
            Update
          </Button>
          <Button
            variant="contained"
            sx={{ mt: 3, mb: 3 }}
            onClick={closeShowProfileModal}
          >
            Cancel
          </Button>
        </Box>
      </Dialog>
    </Container>
  );
}
